import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import IconButton from '@mui/material/IconButton';

import { DashboardT } from 'business/definitions';
import DashboardItemWrapper from 'components/DashboardItemWrapper/DashboardItemWrapper';
import { trackEvent } from 'helpers/trackerHelpers';
import {
    FAVOURITE_DASHBOARDS_QUERY_KEY,
    useToggleFavouriteDashboard,
} from 'routes/Home/hooks/favouriteDashboards';
import { filterDashboardByTitle } from 'routes/Library/helpers';

type Props = {
    dashboard: DashboardT;
    filter: string;
};

const FavouriteDashboardModalItem = ({
    dashboard,
    filter,
}: Props): JSX.Element => {
    const [isFavourite, setIsFavourite] = useState(dashboard.isUserFavourite);
    const queryClient = useQueryClient();

    const onSuccess = () => {
        const willBeFavourite = !isFavourite;
        const event = willBeFavourite
            ? 'decision/homepage/favorites/dashboard-added'
            : 'decision/homepage/favorites/dashboard-removed';
        trackEvent(event);
        queryClient.invalidateQueries({
            queryKey: [FAVOURITE_DASHBOARDS_QUERY_KEY],
        });
    };

    const { mutate: toggleFavouriteDashboard } = useToggleFavouriteDashboard(
        dashboard.key,
        onSuccess,
    );

    const toggleFavourite = (): void => {
        if (!dashboard.key) {
            console.error(
                'dashboard.key should be defined in onToggleFavourite',
            );
            return;
        }
        toggleFavouriteDashboard({ willBeFavourite: !isFavourite });
        setIsFavourite(!isFavourite);
    };

    if (filterDashboardByTitle(dashboard, filter) === null) {
        return <></>;
    }
    return (
        <DashboardItemWrapper
            dataTitle={dashboard.title}
            itemStyle={{ justifyContent: 'space-between' }}
        >
            {dashboard.title}
            <IconButton onClick={toggleFavourite} size="small">
                {isFavourite ? (
                    <StarIcon style={{ color: '#eec800' }} />
                ) : (
                    <StarBorderIcon />
                )}
            </IconButton>
        </DashboardItemWrapper>
    );
};

export default FavouriteDashboardModalItem;
